import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class RelatoriosOperacionaisService {
 private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getRelatorios(
    contractId:string,
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    filterText: string = '',
    filterData: any | null,
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('nomeRelatorioVinculadoOuItemContratual', filterText || '')
      .set('nomeAreaFuncional', filterData?.value?.nomeAreaFuncional || '')
      .set('itemContratual', filterData?.value?.itemContratual || '')
      .set('prazoInicio', filterData?.value?.prazoInicio || '')
      .set('prazoFim', filterData?.value?.prazoFim || '')
      .set('periodoReferenciaInicio', filterData?.value?.periodoReferenciaInicio || '')
      .set('periodoReferenciaFim', filterData?.value?.periodoReferenciaFim || '')
      .set(
        'nomeTipoRelatorioVinculado',
        filterData?.value?.nomeTipoRelatorioVinculado || '',
      );
       if (filterData?.value?.situacaoPrazo) {
      params = params.set('situacaoPrazo' ,filterData?.value?.situacaoPrazo || '')
    }
    return this.http.get(
      this.baseUrl + `/v1/contratos/${contractId}/relatorios-operacionais`,
      { params },
    );
  }
  getRelatoriosAtestados(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    nomeNumeroContratoOuNomeRelatorio: any,
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set(
        'nomeNumeroContratoOuNomeRelatorio',
        nomeNumeroContratoOuNomeRelatorio || '',
      );
    return this.http.get(
      this.baseUrl +
        `/v1/afericoes/relatorios-operacionais/relatorios-atestados`,
      { params },
    );
  }

  getRelatorioPorId(idRelatorio: any, idContract: any) {
    return this.http.get<any[]>(
      this.baseUrl +
        `/v1/contratos/${idContract}/relatorios-operacionais/${idRelatorio}`,
    );
  }
  criarRelatorio(data: any, idContract: any) {
    return this.http.post(
      this.baseUrl + `/v1/contratos/${idContract}/relatorios-operacionais`,
      data,
    );
  }
  atualizarRelatorio(idRelatorio: any, idContract: any, dados: any) {
    return this.http.put(
      this.baseUrl +
        `/v1/contratos/${idContract}/relatorios-operacionais/${idRelatorio}`,
      dados,
    );
  }
  getNomeRelatorio(idTipoRelatorio: string) {
    const validateIdTipoRelatorio = idTipoRelatorio ? idTipoRelatorio : '';
    return this.http.get<any[]>(
      this.baseUrl +
        `/v1/relatorios-vinculados?page=0&size=30&sortField=nome&sortDirection=asc&nome=&descricao=&codigoTipoRelatorioVinculado=${validateIdTipoRelatorio}`,
    );
  }
  getTipoRelatorio() {
    return this.http.get<any[]>(
      this.baseUrl +
        `/v1/tipos-relatorios-vinculados?page=0&size=10&sortField=nome&sortDirection=asc&nome=&descricao=&codigoTipoAbaVinculada=REL_OPER`,
    );
  }
  getAreasFuncionais(idTipoRelatorio?: any) {
    let params = new HttpParams()
      .set('page', '0')
      .set('size', '30')
      .set('sortField', 'nome')
      .set('sortDirection', 'asc')
      .set('nome', '')
      .set('descricao', '');

    if (idTipoRelatorio) {
      params = params.set('idTipoRelatorioVinculado', idTipoRelatorio);
    }

    return this.http.get<any[]>(this.baseUrl + `/v1/areas-funcionais`, {
      params,
    });
  }
  deleteRelatorio(contractId: any, idRelatorio: any) {
    return this.http.delete(
      `${this.baseUrl}/v1/contratos/${contractId}/relatorios-operacionais/${idRelatorio}`,
    );
  }
  deleteRelatorioEmLote(contractId: any, idsRelatorio: any) {
    return this.http.post(
      `${this.baseUrl}/v1/contratos/${contractId}/relatorios-operacionais/excluir-em-lote`,
      idsRelatorio,
    );
  }
  getHistorico(id: string | null, idContrato: any, pageIndex: number = 0) {
    return this.http.get(
      this.baseUrl +
        `/v1/contratos/${idContrato}/relatorios-operacionais/${id}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`,
    );
  }
}
